import React from 'react'
import { useTranslation } from "react-i18next";
import { token } from '@amzn/stencil-design-tokens/js/web/utils';
import { UserType } from "src/constants/usertype";
import RightChevron2 from 'src/images/icon_rightchevron2.svg';
import LeftChevron2 from 'src/images/icon_leftchevron2.svg';
import RightChevronWhite from 'src/images/chevron_white.svg';
import LeftChevronWhite from 'src/images/chevron_white_left.svg';
import { LinkCard } from '@amzn/stencil-react-components/card';
import { recordEvent } from 'src/analytics/amplify';
import { useStencilContext, ThemeMode } from '@amzn/stencil-react-components/context';

interface Props {
    userType: UserType;
    screenName: string;
    header: string;
    iconSrc: string;
    href?: string;
    onClick?: () => any;
}

const recordAndExecute = (userType: string, screenName: string, onClick?: () => any) => {
    recordEvent({
      name: `${screenName}.${userType}.Count`,
      immediate: true
    });
    onClick && onClick();
}

const UserSelectionTile = ({userType,
                            screenName,
                            header,
                            iconSrc,
                            href,
                            onClick}: Props) => {
    const { t, i18n } = useTranslation();
    const { themeMode } = useStencilContext();
    const isDark = themeMode === ThemeMode.Dark;
    const className = 'content-box selection-tile-container custom-link-card';
    const userTypeString = userType.toLowerCase();
    const divId = `${userTypeString}-picker`;
    const textDivId = `${userTypeString}-login-text`;
    const rtl = i18n.dir() === 'rtl';
    const rightChevron = isDark ? RightChevronWhite : RightChevron2;
    const leftChevron = isDark ? LeftChevronWhite : LeftChevron2;

    return (
        <LinkCard data-testid={`${userTypeString}-tile`}
                  id={divId}
                  className={className}
                  height={58}
                  style={{
                      boxShadow: token('shadow.raised-rest'),
                      borderRadius: '0',
                      border: 'none',
                  }}
                  padding={{top: '16px', bottom: '16px', left: '12px', right: '12px'}}
                  onClick={() => {recordAndExecute(userType.toUpperCase(), screenName, onClick)}}
                  href={href}>
            <img className={`icon${rtl ? "-rtl" : ""}`} src={iconSrc} alt="" aria-hidden={true} />
            <div id={textDivId}>
                <div className='tile-header'>{t(header)}</div>
            </div>
            <img className="chevron" src={rtl ? leftChevron : rightChevron} alt="" aria-hidden={true}/>
        </LinkCard>
    )
}

export default UserSelectionTile;
